<template>
    <svg width="40" height="34" viewBox="0 0 40 34" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M19.9466 2.7734C21.9632 1.0929 25.0404 2.30718 25.366 4.91194C26.3694 12.9394 26.3694 21.0606 25.366 29.0881C25.0404 31.6928 21.9632 32.9071 19.9466 31.2266L11.6299 24.296C11.5438 24.2242 11.4353 24.1849 11.3232 24.1849H4.35297C2.50118 24.1849 1 22.6838 1 20.832V13.168C1 11.3162 2.50118 9.81506 4.35297 9.81506H11.3232C11.4353 9.81506 11.5438 9.77577 11.6299 9.70403L19.9466 2.7734Z" stroke="#130F26" stroke-width="2" stroke-linecap="round"/>
        <path d="M29.6476 12.5969C30.2088 12.0357 31.1187 12.0357 31.6798 12.5969L34.0508 14.9678L36.4217 12.5969C36.9828 12.0357 37.8927 12.0357 38.4539 12.5969C39.0151 13.1581 39.0151 14.0679 38.4539 14.6291L36.083 17L38.4539 19.3709C39.0151 19.9321 39.0151 20.8419 38.4539 21.4031C37.8927 21.9643 36.9829 21.9643 36.4217 21.4031L34.0508 19.0322L31.6798 21.4031C31.1187 21.9643 30.2088 21.9643 29.6476 21.4031C29.0865 20.8419 29.0865 19.9321 29.6476 19.3709L32.0185 17L29.6476 14.6291C29.0865 14.0679 29.0865 13.1581 29.6476 12.5969Z" stroke="#130F26" stroke-width="2" stroke-linecap="round"/>
    </svg>
</template>

<script>
    export default {
        name: "MuteIcon"
    }
</script>

<style scoped>

</style>